module.exports = __webpack_public_path__ + "static/logoMainPage-4600e10ee928d4a2230ea388847ddd42.png";